import React, { useEffect, useState } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";

const AddUser = () => {
  const [registered, setRegistered] = useState(false);
  const [register, setRegister] = useState({
    name: "",
    stateid: "",
    status: 1,
  });
  const [formerror, setFormError] = useState("");
  const [languages, setlanguages] = useState([]);
  const [states, setstates] = useState([]);
  const [cities, setcities] = useState([]);

  const resetMessage = (e) => {
    setMessage(() => {
      return {
        type: null,
        message: "",
      };
    });
  };

  const [message, setMessage] = useState({
    type: null,
    text: "",
  });

  const getMessage = () => {
    if (message.type) {
      return (
        <div className={`alert alert-${message.type}`} role="alert">
          <button type="button" className="close" onClick={resetMessage}>
            <span aria-hidden="true">&times;</span>
          </button>
          <strong className="d-block d-sm-inline-block-force">
            {message.type === "success" ? "Well done!" : "Oops!"}
          </strong>{" "}
          {message.message}
        </div>
      );
    }
  };

  const changeData = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setRegister((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
    if (name === "email") {
      setRegister((prev) => {
        return {
          ...prev,
          username: value.split("@")[0],
        };
      });
    }
    if (name === "state") {
      setRegister((prev) => {
        return {
          ...prev,
          city: 0,
        };
      });

      getCity(value);
    }
  };

  const removeError = (e) => {
    setFormError("");
  };

  const validate = () => {
    if (!register.name) {
      setFormError("Please type name.");
      return false;
    }

    if (register.stateid == 0) {
      setFormError("Please select state.");
      return false;
    }

    return true;
  };
  const getSignUp = async (e) => {
    console.log(register);
    let user = JSON.parse(localStorage.getItem("user"));
    //return;
    e.preventDefault();
    if (validate()) {
      try {
        await axios
          .post(localStorage.getItem("basurl") + "/getcities", register, {
            headers: { "mojo-access-tokens": user.token },
          })
          .then((response) => {
            setRegistered(true);
            setMessage(() => {
              return {
                type: "success",
                message: response.data.message,
              };
            });
            setRegister({
              name: "",
              stateid: "",
              status: 1,
            });
          })
          .catch((err) => {
            setFormError(err.response.data.message);
          });
      } catch (err) {
        setFormError(err.message);
      }
    }
  };

  const getLanguage = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/languages")
        .then((response) => {
          setlanguages(response.data);
        })
        .catch((err) => {
          setFormError(err.response.data.message);
        });
    } catch (err) {
      setFormError(err.message);
    }
  };

  const getState = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/states")
        .then((response) => {
          setstates(response.data);
        })
        .catch((err) => {
          setFormError(err.response.data.message);
        });
    } catch (err) {
      setFormError(err.message);
    }
  };

  const getCity = async (val) => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/cities/" + val)
        .then((response) => {
          setcities(response.data);
        })
        .catch((err) => {
          setFormError(err.response.data.message);
        });
    } catch (err) {
      setFormError(err.message);
    }
  };

  useEffect(() => {
    getState();
    getCity(register.state);
  }, []);

  return (
    <>
      <div className="card shadow-base bd-0 pd-20">
        {getMessage()}
        <span className="text-danger">{formerror}</span>
        <form method="post" onSubmit={getSignUp}>
          <div className="row">
            {/* firstname */}
            <div className="col-sm-6">
              <label>City Name</label>
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="icon ion-man tx-16 lh-0 op-6"></i>
                </span>
                <input
                  id="signup-firstname"
                  type="text"
                  name="name"
                  value={register.name}
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please enter first name"
                  className="form-control"
                />
              </div>
            </div>

            {/* state */}
            <div className="col-sm-6">
              <label>State</label>
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="ion ion-ios-navigate tx-16 lh-0 op-6"></i>
                </span>
                <select
                  id="signup-state"
                  name="stateid"
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please choose state"
                  className="form-control"
                  value={register.stateid}
                >
                  <option key="state0" value="0">
                    --select state--
                  </option>
                  {states.map((state) => (
                    <option key={`state` + state.id} value={state.id}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* Active */}
            <div className="col-sm-6">
              <label>Active</label>
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="ion ion-checkmark-circled tx-16 lh-0 op-6"></i>
                </span>

                <select
                  id="status"
                  name="status"
                  className="form-control"
                  onFocus={removeError}
                  onChange={changeData}
                  value={register.status}
                >
                  <option value="1">Active</option>
                  <option value="0">In-Active</option>
                </select>
              </div>
            </div>

            {/* submit */}
            <div className="col-sm-6">
              <label>&nbsp;</label>
              <div className="form-group input-group">
                <button type="submit" className="btn btn-success pull-right">
                  Add City
                </button>
                &nbsp; &nbsp; &nbsp;
                <NavLink to="/masters/cities"> All Cities </NavLink>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};
export default AddUser;
